import { ApplicationState } from '../../store'

export const getLastFetchPrevious = (state: ApplicationState): number =>
  state.cleans.lastFetchPrevious
